import React, { useEffect, useState, useContext } from "react";
import { Link, useHistory } from "react-router-dom";
import axios from "axios";
import { AuthContext } from "../../helpers/AuthContext";
import { matchesAnyRole } from "../../utils/instanceRoleInheritance";
import { canAccessCoreNetwork, CORE_NETWORK_PERMISSIONS, hasAnyCoreNetworkPermission } from "../../helpers/coreNetworkPermissions";
import { CORE_NETWORK_UI_CONFIG_UPDATED_EVENT, normalizeCoreNetworkUiConfig } from "../../helpers/coreNetworkUiConfig";
import BugReportDialog from "./BugReportDialog";

// Icons
import TimelineIcon from "@mui/icons-material/Timeline";
import FireplaceIcon from "@mui/icons-material/Fireplace";
import MessageIcon from "@mui/icons-material/Message";
import CodeIcon from "@mui/icons-material/Code";
import HomeIcon from "@mui/icons-material/Home";
import BuildIcon from "@mui/icons-material/Build";
import PermPhoneMsgIcon from "@mui/icons-material/PermPhoneMsg";
import AssistantIcon from "@mui/icons-material/Assistant";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import TrackChangesIcon from "@mui/icons-material/TrackChanges";
import AssignmentTurnedIn from "@mui/icons-material/AssignmentTurnedIn";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import SmartToyIcon from "@mui/icons-material/SmartToy";
import WebIcon from "@mui/icons-material/Web";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import Diversity3Icon from "@mui/icons-material/Diversity3";

import DashboardIcon from "@mui/icons-material/Dashboard";

import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

import MenuIcon from "@mui/icons-material/Menu";

import './InstanceLeftSidebar.css';


import BugReportIcon from "@mui/icons-material/BugReport";

import {
  Box,
  Chip,
  Tooltip,
} from "@mui/material";


import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded";
import KeyboardArrowRightRoundedIcon from "@mui/icons-material/KeyboardArrowRightRounded";
import RadioButtonCheckedRoundedIcon from "@mui/icons-material/RadioButtonCheckedRounded";

import { useLocation } from "react-router-dom";




const menuItems = [
  {
    title: "Connect",
    icon: <PermPhoneMsgIcon />,
    path: "/instance/",
    allowedRoles: [
      "administrator",
      "finance-rep",
      "analytics-rep",
      "promostores-manager",
      "order-rep",
      "client-rep",
      "demo-user",
      "purchasing-rep",
      "design-rep",
      "shipping-rep",
      "production-rep",
    ],
    submenu: [
      {
        label: "Feed And Activity",
        slug: "feed-and-activity",
        allowedRoles: [
          "administrator",
          "finance-rep",
          "analytics-rep",
          "promostores-manager",
          "order-rep",
          "client-rep",
          "demo-user",
          "purchasing-rep",
          "design-rep",
          "shipping-rep",
          "production-rep",
        ],
      },
      {
        label: "Suppliers",
        slug: "suppliers",
        allowedRoles: [
          "administrator",
          "finance-rep",
          "analytics-rep",
          "promostores-manager",
          "order-rep",
          "client-rep",
          "demo-user",
          "purchasing-rep",
          "design-rep",
          "shipping-rep",
          "production-rep",
        ],
      },
      {
        label: "Products",
        slug: "products",
        allowedRoles: [
          "administrator",
          "finance-rep",
          "analytics-rep",
          "promostores-manager",
          "order-rep",
          "client-rep",
          "demo-user",
          "purchasing-rep",
          "design-rep",
          "shipping-rep",
          "production-rep",
        ],
      },
    ],
  },
  {
    title: "Sales",
    icon: <TimelineIcon />,
    path: "/instance/",
    allowedRoles: [
      "administrator",
      "finance-rep",
      "analytics-rep",
      "promostores-manager",
      "purchasing-rep",
      "order-rep",
      "client-rep",
      "demo-user",
      "design-rep",
      "shipping-rep",
      "production-rep",
    ],
    submenu: [
      {
        label: "Projects",
        slug: "orders",
        allowedRoles: [
          "administrator",
          "finance-rep",
          "analytics-rep",
          "order-rep",
          "client-rep",
          "purchasing-rep",
          "design-rep",
          "shipping-rep",
          "production-rep",
        ],
      },
      {
        label: "Pipeline",
        slug: "pipeline",
        allowedRoles: [
          "administrator",
          "finance-rep",
          "analytics-rep",
          "order-rep",
          "client-rep",
          "purchasing-rep",
          "design-rep",
          "shipping-rep",
          "production-rep",
        ],
      },
      {
        label: "Customers & Leads",
        slug: "leads",
        allowedRoles: [
          "administrator",
          "finance-rep",
          "analytics-rep",
          "promostores-manager",
          "order-rep",
          "client-rep",
          "purchasing-rep",
          "demo-user",
          "design-rep",
          "shipping-rep",
          "production-rep",
        ],
      },
      {
        label: "Prospects",
        slug: "prospects",
        allowedRoles: [
          "administrator",
          "finance-rep",
          "analytics-rep",
          "promostores-manager",
          "order-rep",
          "client-rep",
          "purchasing-rep",
          "demo-user",
          "design-rep",
          "shipping-rep",
          "production-rep",
        ],
      },
      /*{
        label: "Customers",
        slug: "customers",
        allowedRoles: ["administrator", "analytics-rep", "promostores-manager", "order-rep", "client-rep", "demo-user"],
      },*/
      {
        label: "PromoStores",
        slug: "promostores",
        allowedRoles: [
          "administrator",
          "analytics-rep",
          "promostores-manager",
          "order-rep",
          "client-rep",
        ],
      },
      /*,
      {
        label: "Analytics",
        slug: "analytics",
        allowedRoles: ["administrator", "analytics-rep", "order-rep", "client-rep"],
      },*/
    ],
  },
  {
    title: "Operations",
    icon: <AssistantIcon />,
    path: "/instance/",
    allowedRoles: ["administrator", "operations-rep", "finance-rep"],
    submenu: [
      {
        label: "Sales Operations",
        slug: "sales-operations",
        buildPath: (instanceUniqueId) =>
          `/instance/${instanceUniqueId}/operations/sales-operations`,
        allowedRoles: ["administrator", "operations-rep", "finance-rep"],
      },
      {
        label: "Management",
        slug: "management",
        allowedRoles: ["administrator", "operations-rep", "finance-rep"],
      },
    ],
  },
  {
    title: "Purchasing",
    icon: <AssignmentTurnedIn />,
    path: "/instance/",
    allowedRoles: [
      "administrator",
      "purchasing-rep",
      "design-rep",
      "shipping-rep",
      "production-rep",
    ],
    submenu: [
      {
        label: "Dashboard",
        slug: "dashboard",
        allowedRoles: [
          "administrator",
          "purchasing-rep",
          "design-rep",
          "shipping-rep",
          "production-rep",
        ],
      },
      /*{
      label: "Analytics",
        slug: "analytics",
        allowedRoles: ["administrator", "purchasing-rep"],
      },*/
    ],
  },
  {
    title: "Finance",
    icon: <MonetizationOnIcon />,
    path: "/instance/",
    allowedRoles: ["administrator", "finance-rep"],
    submenu: [
      {
        label: "Billing",
        slug: "billing",
        allowedRoles: ["administrator", "finance-rep"],
      },
      {
        label: "Invoicing",
        slug: "invoicing",
        allowedRoles: ["administrator", "finance-rep"],
      },
    ],
  },
  {
    title: "Core Network",
    icon: <Diversity3Icon />,
    path: "/instance/",
    allowedRoles: [
      "administrator",
      "order-rep",
      "client-rep",
      "design-rep",
      "production-rep",
      "purchasing-rep",
      "operations-rep",
    ],
    submenu: [
      {
        label: "Dashboard",
        slug: "dashboard",
        buildPath: (instanceUniqueId) => `/instance/${instanceUniqueId}/core-network/dashboard`,
        allowedRoles: [
          "administrator",
          "order-rep",
          "client-rep",
          "design-rep",
          "production-rep",
          "purchasing-rep",
          "finance-rep",
          "operations-rep",
        ],
      },
      {
        label: "Work Requests",
        slug: "work-requests",
        buildPath: (instanceUniqueId) => `/instance/${instanceUniqueId}/core-network/work-requests`,
        allowedRoles: [
          "administrator",
          "order-rep",
          "client-rep",
          "design-rep",
          "production-rep",
          "purchasing-rep",
          "finance-rep",
          "operations-rep",
        ],
      },
      {
        label: "Talent",
        slug: "talent",
        buildPath: (instanceUniqueId) => `/instance/${instanceUniqueId}/core-network/talent`,
        allowedRoles: [
          "administrator",
          "order-rep",
          "client-rep",
          "design-rep",
          "production-rep",
          "purchasing-rep",
          "finance-rep",
          "operations-rep",
        ],
      },
      {
        label: "Matches",
        slug: "matches",
        buildPath: (instanceUniqueId) => `/instance/${instanceUniqueId}/core-network/matches`,
        allowedRoles: [
          "administrator",
          "order-rep",
          "client-rep",
          "design-rep",
          "production-rep",
          "purchasing-rep",
          "finance-rep",
          "operations-rep",
        ],
      },
      {
        label: "Settings",
        slug: "settings",
        buildPath: (instanceUniqueId) => `/instance/${instanceUniqueId}/core-network/settings`,
        allowedRoles: ["administrator", "admin"],
      },
    ],
  },
  {
    title: "Production",
    icon: <BuildIcon />,
    path: "/instance/",
    allowedRoles: ["administrator", "production-rep", "purchasing-rep"],
    submenu: [
      // {
      //   label: "Dashboard",
      //   slug: "dashboard",
      //   allowedRoles: ["administrator", "production-rep"],
      // },
      {
        label: "Production Overview",
        slug: "overview/dashboard",
        icon: <DashboardIcon />,
        allowedRoles: ["administrator", "production-rep", "purchasing-rep"],
      },
      {
        label: "Production Planning",
        slug: "production",
        allowedRoles: ["administrator", "production-rep", "purchasing-rep"],
      },

      // {
      //   label: "Embroidery",
      //   slug: "embroidery",
      //   allowedRoles: ["administrator", "production-rep"],
      // },
      // {
      //   label: "Direct to Film",
      //   slug: "direct-to-film",
      //   allowedRoles: ["administrator", "production-rep"],
      // },
      // {
      //   label: "Cresting",
      //   slug: "cresting",
      //   allowedRoles: ["administrator", "production-rep"],
      // },
      //  {
      //   label: "Engraving",
      //   slug: "engraving",
      //   allowedRoles: ["administrator", "production-rep"],
      // },
      //  {
      //   label: "Screening",
      //   slug: "screening",
      //   allowedRoles: ["administrator", "production-rep"],
      // },
      // {
      //   label: "Awards",
      //   slug: "awards",
      //   allowedRoles: ["administrator", "production-rep"],
      // },
      // {
      //   label: "Analytics",
      //   slug: "analytics",
      //   allowedRoles: ["administrator", "production-rep"],
      // },
      // {
      //   label: "Machines Management",
      //   slug: "machines-management",
      //   allowedRoles: ["administrator", "production-rep"],
      // },
      // {
      //   label: "Department Management",
      //   slug: "department-management",
      //   allowedRoles: ["administrator", "production-rep"],
      // },
    ],
  },

  {
    title: "Shipping",
    icon: <LocalShippingIcon />,
    path: "/instance/",
    allowedRoles: [
      "administrator",
      "shipping-rep",
      "purchasing-rep",
      "production-rep",
    ],
    submenu: [
      {
        label: "Receiving",
        slug: "receiving",
        allowedRoles: [
          "administrator",
          "shipping-rep",
          "purchasing-rep",
          "production-rep",
        ],
      },
      {
        label: "Warehouse Builder",
        slug: "warehouse-builder",
        allowedRoles: [
          "administrator",
          "shipping-rep",
          "purchasing-rep",
          "production-rep",
        ],
      },
    ],
  },
  {
    title: "Ezee AI",
    icon: <SmartToyIcon />,
    path: "/instance/",
    allowedRoles: [
      "administrator",
      "operations-rep",
      "sales-rep",
      "super-administrator",
      "admin",
      "finance-rep",
      "analytics-rep",
      "promostores-manager",
      "order-rep",
      "client-rep",
      "demo-user",
      "purchasing-rep",
      "design-rep",
      "shipping-rep",
      "production-rep",
      "marketing-rep",
    ],
    submenu: [
      {
        label: "Ask Ezee",
        slug: "brain",
        buildPath: (instanceUniqueId) => `/instance/${instanceUniqueId}/ai/brain`,
        allowedRoles: [
      "administrator",
      "finance-rep",
      "analytics-rep",
      "promostores-manager",
      "order-rep",
      "client-rep",
      "demo-user",
      "purchasing-rep",
      "design-rep",
      "shipping-rep",
      "production-rep",
      "marketing-rep",
    ],
      },
      {
        label: "AI Actions",
        slug: "actions",
        buildPath: (instanceUniqueId) => `/instance/${instanceUniqueId}/ai/actions`,
        allowedRoles: ["administrator"],
      },
      {
        label: "AI Settings",
        slug: "settings",
        buildPath: (instanceUniqueId) => `/instance/${instanceUniqueId}/ai/settings`,
        allowedRoles: ["administrator"],
      },
    ],
  },
  {
    title: "Showcase",
    icon: <WebIcon />,
    path: "/instance/",
    allowedRoles: ["administrator"],
    submenu: [
      {
        label: "Dashboard",
        slug: "dashboard",
        allowedRoles: ["administrator"],
        requiresPromoShowcase: true,
        buildPath: (instanceUniqueId) =>
          `/instance/${instanceUniqueId}/dashboard/promoshowcase`,
      },
    ],
  },
  {
    title: "Reports",
    icon: <TrackChangesIcon />,
    path: "/instance/",
    allowedRoles: ["administrator", "analytics-rep", "finance-rep", "client-rep", "order-rep"],
    submenu: [
      {
        label: "Dashboard",
        slug: "dashboard",
        allowedRoles: ["administrator", "analytics-rep", "finance-rep"],
      },
      {
        label: "Sales Rep",
        slug: "sales-rep",
        allowedRoles: ["administrator", "finance-rep", "client-rep", "order-rep"],
      },
    ],
  },
  {
    title: "Settings",
    icon: <AccountTreeIcon />,
    path: "/instance/",
    allowedRoles: ["administrator", "admin", "manager", "finance-rep", "super-administrator"],
    submenu: [
      {
        label: "Users",
        slug: "users",
        allowedRoles: ["administrator", "finance-rep"],
      },

      {
        label: "Integrations",
        slug: "global-settings/integrations",
        allowedRoles: ["administrator", "finance-rep"],
      },
      {
        label: "Company Settings",
        slug: "global-settings/company-settings",
        allowedRoles: ["administrator", "admin", "manager", "finance-rep"],
      },

      /*{
        label: "Global Settings",
        slug: "global-settings",
        allowedRoles: ["administrator"],
      },*/
    ],
  },
];

/*const functionItems = [
  { title: "Product search", icon: <BuildIcon />, path: "/instance/connect/products" },
  //{ title: "Website Sync", icon: <AssistantIcon />, path: "/instance/website-sync" },
];*/

const toSlug = (text = "") =>
  text
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");

function resolveInstanceUniqueIdFromPathname(pathname = "") {
  const match = String(pathname || "").match(/^\/instance\/([^/]+)/);
  return match ? decodeURIComponent(match[1]) : "";
}

function InstanceLeftSidebar() {
  const { authState } = useContext(AuthContext);
  const [instanceObject, setInstanceObject] = useState({});
  const [loadingComplete, setLoadingComplete] = useState("");
  const userRole = authState.role;

  const [bugModalOpen, setBugModalOpen] = useState(false);

  const openBugModal = () => setBugModalOpen(true);
  const closeBugModal = () => setBugModalOpen(false);

  const [isCollapsed, setIsCollapsed] = useState(() => {
    try {
      return localStorage.getItem("ec_sidebar_collapsed") === "true";
    } catch {
      return false;
    }
  });
  const [isHovering, setIsHovering] = useState(false);
  const showExpanded = !isCollapsed || isHovering;

  const toggleCollapse = () => {
    const next = !isCollapsed;
    setIsCollapsed(next);
    if (isHovering) setIsHovering(false);
    try {
      localStorage.setItem("ec_sidebar_collapsed", String(next));
    } catch {}
  };

  // Only show the menus this role is allowed to see
  const filteredMenu = menuItems.filter((item) =>
    matchesAnyRole(userRole, item.allowedRoles),
  );

  const location = useLocation();
  const isProductionRoute = /^\/instance\/[^/]+\/production(?:\/|$)/.test(location.pathname);
  const [openMenus, setOpenMenus] = useState(() =>
    isProductionRoute ? { Production: true } : {}
  );
  const history = useHistory();

  // Production pages own their sidebar instance. Keep the active section
  // expanded across route changes and remounts without changing other menus.
  useEffect(() => {
    if (!isProductionRoute) return;
    setOpenMenus((prev) =>
      prev.Production ? prev : { ...prev, Production: true }
    );
  }, [isProductionRoute, location.pathname]);
  const instanceUniqueId = resolveInstanceUniqueIdFromPathname(location.pathname);
  const coreNetworkUiConfig = normalizeCoreNetworkUiConfig(
    instanceObject?.aiSettings?.coreNetworkAdmin || null
  );

  const toggleMenu = (title) => {
    setOpenMenus((prev) => ({ ...prev, [title]: !prev[title] }));
  };

  // 1. Filter out any top‑level items the user shouldn’t see
  const isPromoShowcaseEnabled = Boolean(
    instanceObject?.promoShowcaseSettings?.enabled,
  );
  const hideEzeeForNonAdmins = instanceObject?.aiSettings?.ezeeUi?.hideSidebarForNonAdmins === true;
  const isEzeeSidebarAdmin = ["administrator", "super-administrator", "admin"].includes(String(userRole || "").trim().toLowerCase());
  const visibleMenus = menuItems
    .filter((item) => matchesAnyRole(userRole, item.allowedRoles))
    .filter((item) => !(item.title === "Ezee AI" && hideEzeeForNonAdmins && !isEzeeSidebarAdmin))
    // 2. Within each, filter its submenu by role
    .map((item) => ({
      ...item,
      submenu: item.submenu
        .filter((sub) => {
          if (!matchesAnyRole(userRole, sub.allowedRoles)) return false;
          if (sub.requiresPromoShowcase && !isPromoShowcaseEnabled) return false;
          if (item.title === "Core Network") {
            if (!canAccessCoreNetwork(authState, instanceUniqueId)) return false;
            if (sub.slug === "matches" && coreNetworkUiConfig.matchesEnabled === false) return false;
            const permissionMap = {
              dashboard: [CORE_NETWORK_PERMISSIONS.VIEW_DASHBOARD],
              "work-requests": [CORE_NETWORK_PERMISSIONS.VIEW_REQUEST],
              talent: [CORE_NETWORK_PERMISSIONS.VIEW_MEMBERS],
              matches: [
                CORE_NETWORK_PERMISSIONS.GENERATE_MATCHES,
                CORE_NETWORK_PERMISSIONS.SEND_OFFERS,
                CORE_NETWORK_PERMISSIONS.ASSIGN_REQUEST,
              ],
              settings: [CORE_NETWORK_PERMISSIONS.MANAGE_SETTINGS],
            };
            return hasAnyCoreNetworkPermission(
              authState,
              permissionMap[sub.slug] || [CORE_NETWORK_PERMISSIONS.VIEW_DASHBOARD],
              instanceUniqueId
            );
          }
          return true;
        })
        .map((sub) => {
          if (item.title !== "Core Network") return sub;
          if (sub.slug === "work-requests") {
            return { ...sub, label: coreNetworkUiConfig.workRequestsLabel };
          }
          if (sub.slug === "talent") {
            return { ...sub, label: coreNetworkUiConfig.talentLabel };
          }
          return sub;
        }),
    }))
    // 3. Drop any section that now has no submenu items
    .filter((item) => item.submenu.length > 0);

  useEffect(() => {
    if (!instanceUniqueId) return;

    if (!localStorage.getItem("accessToken")) {
      history.push("/login");
      return;
    }

    let active = true;
    axios
      .get(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/instances/byinstanceUniqueId/${instanceUniqueId}`,
      )
      .then((response) => {
        if (!active) return;
        setInstanceObject(response.data);
        setLoadingComplete(true);
      })
      .catch(() => {
        if (!active) return;
        setLoadingComplete(false);
      });

    return () => {
      active = false;
    };
  }, [history, instanceUniqueId]);

  useEffect(() => {
    const handleUiConfigUpdated = (event) => {
      const nextUiConfig = normalizeCoreNetworkUiConfig(event?.detail || null);
      setInstanceObject((prev) => ({
        ...(prev || {}),
        aiSettings: {
          ...((prev && prev.aiSettings) || {}),
          coreNetworkAdmin: {
            ...((((prev && prev.aiSettings) || {}).coreNetworkAdmin) || {}),
            ...nextUiConfig,
          },
        },
      }));
    };

    window.addEventListener(CORE_NETWORK_UI_CONFIG_UPDATED_EVENT, handleUiConfigUpdated);
    return () => {
      window.removeEventListener(CORE_NETWORK_UI_CONFIG_UPDATED_EVENT, handleUiConfigUpdated);
    };
  }, []);

  const [dynamicDepartments, setDynamicDepartments] = useState([]);

  const fetchDepartments = async () => {
    if (!instanceUniqueId) return;
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/production/departments?active=true&instanceUniqueId=${encodeURIComponent(instanceUniqueId)}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        },
      );

      if (Array.isArray(res.data?.data)) {
        setDynamicDepartments(
          res.data.data.map((d) => ({
            label: d.name,
            slug: toSlug(d.name),
            allowedRoles: ["administrator", "production-rep", "purchasing-rep"],
          })),
        );
      }
    } catch (err) {
      console.error("Sidebar departments failed to load", err);
    }
  };

  useEffect(() => {
    fetchDepartments();
  }, [instanceUniqueId]);

  useEffect(() => {
    const handleRefresh = () => {
      fetchDepartments();
    };

    window.addEventListener("production-sidebar-refresh", handleRefresh);

    return () => {
      window.removeEventListener("production-sidebar-refresh", handleRefresh);
    };
  }, []);

  if (
    loadingComplete !== true ||
    instanceObject?.typeOfCore !== "promo-company"
  )
    return null;



      const getMenuBasePath = (title) =>
    `/instance/${instanceUniqueId}/${title.toLowerCase()}`;

  const getSubmenuPath = (title, path, slug, buildPath) =>
    buildPath
      ? buildPath(instanceUniqueId)
      : `${path}${instanceUniqueId}/${title.toLowerCase()}/${slug}`;

  const isPathActive = (targetPath) => {
    if (!targetPath) return false;
    return location.pathname === targetPath || location.pathname.startsWith(`${targetPath}/`);
  };

  const isMenuActive = (title, submenu = []) => {
    return submenu.some(({ slug, buildPath, path }) =>
      isPathActive(
        buildPath
          ? buildPath(instanceUniqueId)
          : `${path || "/instance/"}${instanceUniqueId}/${title.toLowerCase()}/${slug}`,
      ),
    );
  };

  const productionDepartmentIsActive = (slug) =>
    isPathActive(`/instance/${instanceUniqueId}/production/${slug}`);

  return (
    <div
      className={`leftSide${isCollapsed ? " sidebar-collapsed" : ""}`}
      data-testid="instance-left-sidebar"
      onMouseEnter={() => isCollapsed && setIsHovering(true)}
      onMouseLeave={() => setIsHovering(false)}
    >
      <div
        className={`ec-instance-core-nav${
          isCollapsed && isHovering ? " nav-peek" : ""
        }`}
      >

        
          <button
  className="sidebar-collapse-btn"
  onClick={toggleCollapse}
  title={isCollapsed ? "Expand sidebar" : "Collapse sidebar"}
>
  <MenuIcon fontSize="small" />
</button>

        <div className="sidebar">


          
          {/* Toggle button */}
          {/* <button
            className="sidebar-collapse-btn"
            onClick={toggleCollapse}
            title={isCollapsed ? "Expand sidebar" : "Collapse sidebar"}
          >
            {isCollapsed ? (
              <ChevronRightIcon fontSize="small" />
            ) : (
              <ChevronLeftIcon fontSize="small" />
            )}
          </button> */}

{/* 
          <button
  className="sidebar-collapse-btn"
  onClick={toggleCollapse}
  title={isCollapsed ? "Expand sidebar" : "Collapse sidebar"}
>
  <MenuIcon fontSize="small" />
</button> */}

          {/* {visibleMenus.map(({ title, icon, path, submenu }) => (
            <div key={title} className="list-item">
              <div
                className={`menu-header${
                  openMenus[title] && showExpanded ? " menu-header--open" : ""
                }`}
                onClick={() => {
                  if (isCollapsed && !isHovering) {
                    setIsHovering(true);
                    return;
                  }
                  toggleMenu(title);
                }}
              >
                <span className="list-item-icon">{icon}</span>
                {showExpanded && (
                  <>
                    <span className="list-item-text">{title}</span>
                    <span className="menu-chevron">
                      {openMenus[title] ? "▾" : "▸"}
                    </span>
                  </>
                )}
              </div>

              {showExpanded && openMenus[title] && (
                <div className="submenu">
                  {submenu.map(({ label, slug, buildPath }) => (
                    <Link
                      key={slug}
                      to={
                        buildPath
                          ? buildPath(instanceUniqueId)
                          : `${path}${instanceUniqueId}/${title.toLowerCase()}/${slug}`
                      }
                      className="submenu-item"
                    >
                      {label}
                    </Link>
                  ))}

                  
                  {title === "Production" && submenu.length > 0 && (
                    <div className="submenu-divider" />
                  )}
                  {title === "Production" &&
                    dynamicDepartments.map(({ label, slug }) => (
                      <Link
                        key={`dept-${slug}`}
                        to={`${path}${instanceUniqueId}/production/${slug}`}
                        className="submenu-item"
                      >
                        {label}
                      </Link>
                    ))}
                  {title === "Production" && (
                    <>
                      <Link
                        to={`${path}${instanceUniqueId}/production/machines-management`}
                        className="submenu-item"
                      >
                        Machines Management
                      </Link>
                      <Link
                        to={`${path}${instanceUniqueId}/production/department-management`}
                        className="submenu-item"
                      >
                        Department Management
                      </Link>
                      <Link
                        to={`${path}${instanceUniqueId}/production/materials-management`}
                        className="submenu-item"
                      >
                        Materials Management
                      </Link>
                      <Link
                        to={`${path}${instanceUniqueId}/production/charge-strategies`}
                        className="submenu-item"
                      >
                        Charge Strategies
                      </Link>
                    </>
                  )}
                </div>
              )}
            </div>
          ))} */}


         {visibleMenus.map(({ title, icon, path, submenu }) => {
  const sectionActive =
    isMenuActive(
      title,
      submenu.map((sub) => ({ ...sub, path })),
    ) ||
    (title === "Production" &&
      dynamicDepartments.some(({ slug }) => productionDepartmentIsActive(slug)));

  return (
    <div
      key={title}
      className={`list-item ${sectionActive ? "list-item--section-active" : ""}`}
    >
      <Tooltip
        title={!showExpanded ? title : ""}
        placement="right"
        arrow
      >
        <div
          className={`menu-header ${
            openMenus[title] && showExpanded ? "menu-header--open" : ""
          } ${sectionActive ? "menu-header--active" : ""}`}
          onClick={() => {
            if (isCollapsed && !isHovering) {
              setIsHovering(true);
              return;
            }
            toggleMenu(title);
          }}
        >
          <span className="list-item-icon">
            <span className="list-item-icon-inner">{icon}</span>
          </span>

          {showExpanded && (
            <>
              <span className="list-item-text-wrap">
                <span className="list-item-text">{title}</span>
                {sectionActive && (
                  <span className="list-item-caption">Active module</span>
                )}
              </span>

              <span className="menu-chevron">
                {openMenus[title] ? (
                  <KeyboardArrowDownRoundedIcon fontSize="small" />
                ) : (
                  <KeyboardArrowRightRoundedIcon fontSize="small" />
                )}
              </span>
            </>
          )}
        </div>
      </Tooltip>

      {showExpanded && openMenus[title] && (
        <div className="submenu">
          {submenu.map(({ label, slug, buildPath }) => {
            const targetPath = getSubmenuPath(title, path, slug, buildPath);
            const active = isPathActive(targetPath);

            return (
              <Link
                key={slug}
                to={targetPath}
                className={`submenu-item ${active ? "submenu-item--active" : ""}`}
              >
                <span className="submenu-item-bullet">
                  {active ? (
                    <RadioButtonCheckedRoundedIcon style={{ fontSize: 12 }} />
                  ) : (
                    <FiberManualRecordIcon style={{ fontSize: 8 }} />
                  )}
                </span>
                <span className="submenu-item-label">{label}</span>
                {active && (
                  <Chip
                    label="Open"
                    size="small"
                    className="submenu-item-chip"
                  />
                )}
              </Link>
            );
          })}

          {title === "Production" && submenu.length > 0 && (
            <>
              <div className="submenu-divider" />
              <div className="submenu-subheading">Departments</div>
            </>
          )}

          {title === "Production" &&
            dynamicDepartments.map(({ label, slug }) => {
              const targetPath = `${path}${instanceUniqueId}/production/${slug}`;
              const active = productionDepartmentIsActive(slug);

              return (
                <Link
                  key={`dept-${slug}`}
                  to={targetPath}
                  className={`submenu-item submenu-item--department ${
                    active ? "submenu-item--active" : ""
                  }`}
                >
                  <span className="submenu-item-bullet">
                    {active ? (
                      <RadioButtonCheckedRoundedIcon style={{ fontSize: 12 }} />
                    ) : (
                      <FiberManualRecordIcon style={{ fontSize: 8 }} />
                    )}
                  </span>
                  <span className="submenu-item-label">{label}</span>
                  <span className="submenu-item-meta">Dept</span>
                </Link>
              );
            })}

          {title === "Production" && (
            <>
              <div className="submenu-divider" />
              <div className="submenu-subheading">Management</div>

              {[
                { label: "Machines Management", slug: "machines-management" },
                { label: "Department Management", slug: "department-management" },
                { label: "Materials Management", slug: "materials-management" },
                { label: "Charge Strategies", slug: "charge-strategies" },
              ].map((item) => {
                const targetPath = `${path}${instanceUniqueId}/production/${item.slug}`;
                const active = isPathActive(targetPath);

                return (
                  <Link
                    key={item.slug}
                    to={targetPath}
                    className={`submenu-item submenu-item--admin ${
                      active ? "submenu-item--active" : ""
                    }`}
                  >
                    <span className="submenu-item-bullet">
                      {active ? (
                        <RadioButtonCheckedRoundedIcon style={{ fontSize: 12 }} />
                      ) : (
                        <FiberManualRecordIcon style={{ fontSize: 8 }} />
                      )}
                    </span>
                    <span className="submenu-item-label">{item.label}</span>
                  </Link>
                );
              })}
            </>
          )}
        </div>
      )}
    </div>
  );
})}
          {/* Report bug */}
          {/* <div className="list-heading">{showExpanded ? "FUNCTION" : ""}</div>
        <div className="list-item sidebar-bug-item" onClick={openBugModal} style={{ cursor: "pointer" }}>
          <div className="menu-header">
            <span className="list-item-icon">🐞</span>
            {showExpanded && <span className="list-item-text">Report bug</span>}
          </div>
        </div> */}

          {/* Report Bug */}
          {/* <div className="list-heading">{showExpanded ? "SUPPORT" : ""}</div>
          <div
            className="list-item sidebar-bug-item"
            onClick={openBugModal}
            style={{ cursor: "pointer" }}
          >
            <div className="menu-header">
              <span className="list-item-icon">
                <BugReportIcon fontSize="small" />
              </span>
              {showExpanded && (
                <span className="list-item-text">Report a Bug</span>
              )}
            </div>
          </div> */}
{/* Temporarily hide the Report a Bug sidebar entry; retain implementation for restoration. */}
{false && (
  <>
<div className="list-heading">{showExpanded ? "Support" : ""}</div>

<div
  className="list-item sidebar-bug-item"
  onClick={openBugModal}
  style={{ cursor: "pointer" }}
>
  <Tooltip title={!showExpanded ? "Report a Bug" : ""} placement="right" arrow>
    <div className="menu-header menu-header--support">
      <span className="list-item-icon">
        <span className="list-item-icon-inner list-item-icon-inner--danger">
          <BugReportIcon fontSize="small" />
        </span>
      </span>

      {showExpanded && (
        <>
          <span className="list-item-text-wrap">
            <span className="list-item-text">Report a Bug</span>
            <span className="list-item-caption">Support & issue tracking</span>
          </span>
        </>
      )}
    </div>
  </Tooltip>
</div>
  </>
)}
        </div>
      </div>

      {/* {bugModalOpen && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.35)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
          }}
          onClick={closeBugModal}
        >
          <div
            style={{
              width: "min(640px, 92vw)",
              background: "#fff",
              borderRadius: 12,
              boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
              padding: 20,
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <h3 style={{ margin: 0 }}>Report a bug</h3>
              <button
                onClick={closeBugModal}
                style={{
                  border: "none",
                  background: "transparent",
                  fontSize: 22,
                  cursor: "pointer",
                }}
              >
                ×
              </button>
            </div>
            <p style={{ marginTop: 8, color: "#555" }}>
              Tell us what went wrong. Include steps to reproduce if possible.
            </p>
            <textarea
              value={bugText}
              onChange={(e) => setBugText(e.target.value)}
              placeholder="Describe the issue..."
              rows={7}
              style={{
                width: "100%",
                border: "1px solid #ddd",
                borderRadius: 8,
                padding: 12,
                outline: "none",
                resize: "vertical",
                fontFamily: "inherit",
                fontSize: 14,
                boxSizing: "border-box",
              }}
            />
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: 8,
                marginTop: 12,
              }}
            >
              <button
                onClick={closeBugModal}
                disabled={sending}
                style={{
                  padding: "8px 12px",
                  borderRadius: 8,
                  border: "1px solid #ddd",
                  background: "#fff",
                  cursor: "pointer",
                }}
              >
                Cancel
              </button>
              <button
                onClick={sendBug}
                disabled={sending}
                style={{
                  padding: "8px 12px",
                  borderRadius: 8,
                  border: "none",
                  background: "#111827",
                  color: "#fff",
                  cursor: "pointer",
                }}
              >
                {sending ? "Sending…" : "Send"}
              </button>
            </div>
          </div>
        </div>
      )} */}

      <BugReportDialog
        open={bugModalOpen}
        onClose={closeBugModal}
        instanceUniqueId={instanceUniqueId}
        accessToken={localStorage.getItem("accessToken")}
        serverUrl={process.env.REACT_APP_NODEJS_SERVER_URL}
      />


    </div>
  );
}

export default InstanceLeftSidebar;


